export const SHS_ADMIN_BASE_URL = "https://api.shsadmissions.com";
// export const SHS_ADMIN_BASE_URL = "http://localhost:8080";
